import React from "react";
import * as S from "./CmpYesNoList.style";
import { useTranslation } from "react-i18next";

// pipes
import * as P from "../../../../../../../utils/pipes";
import Popup from "reactjs-popup";
import { PopUpPayload } from "../genericTemplate/GenericTemplate.style";

function CmpYesNoList({
  item,
  insertfunction,
  customFormChangeItem,
  disabled
}) {
  const {t, i18n: { language }} = useTranslation("global");

  const yesNoItems = [
    {
      key: 'yes',
      name: t("globally.yes")
    },
    {
      key: 'no',
      name: t("globally.no")
    }
  ]

  const changeOptionItem = (customField, fieldOption) => {

    if (disabled) return;
    
    const userToCustomFormField = {
      customFormFieldId: customField.id,
      parentKey: item?.customFormTypeField?.fieldOptions.find(field => field.key === fieldOption?.key)?.parentKey,
      customFormFieldParentId: item?.customFormFieldParentId,
      value: fieldOption.name,
      key: fieldOption.key
    }
    insertfunction(userToCustomFormField)
  }

  const optionKey = customFormChangeItem && customFormChangeItem.key;

  return (
    <S.CmpYesNoList 
      active={optionKey === 'yes' ? true : false}
      disabled={disabled} 
    >
      <div className="selection-container">
        <div className="title">
          <div className="title__text">
            {P.dataTranslation(item?.fieldName, language)}
          </div>
          {
            optionKey
            ? <i className="title__icon icon zaia-i-check-1"></i>
            : <div className="title__required error">{!item.optional && "*"}</div>
          }
          <Popup
            trigger={
              <i className="title__icon-payload icon zaia-alert"></i>
            }
            on={['hover', 'focus']}
            closeOnDocumentClick
            keepTooltipInside
            position={['right center']}
            nested
          >
            <PopUpPayload>
              <p>
              {P.dataTranslation(item.descript, language)}
              </p>
            </PopUpPayload>
          </Popup>
        </div>
        <div className="input-container">
          <div className="list-states">
            <div className={`state ${optionKey === 'yes' && 'state--selected'}`} onClick={() => optionKey === 'yes' ? null : changeOptionItem(item, yesNoItems[0])}>{yesNoItems[0].name}</div>
            <div className="state-separator"></div>
            <div className={`state ${optionKey === 'no' && 'state--selected'}`} onClick={() => optionKey === 'no' ? null : changeOptionItem(item, yesNoItems[1])}>{yesNoItems[1].name}</div>
          </div>
        </div>
      </div>
    </S.CmpYesNoList>
  );
}

export default CmpYesNoList;
